import { Directive } from '@angular/core';

@Directive({
  selector: '[libProduktTypGroupData]'
})
export class ProduktTypGroupDataDirective {

  constructor() { }

}
